import { useNavigate } from "react-router-dom";
import ForgotPasswordPopup from "./forgot-password-popup";
import { routes } from "../../../constants/routes";

const ForgotPasswordPage = () => {
  const navigate = useNavigate();

  return (
    <ForgotPasswordPopup
      open={true}
      onClose={() => navigate(routes.PROVIDER_LOGIN)}
      onBackToLogin={() => navigate(routes.PROVIDER_LOGIN)}
    />
  );
};

export default ForgotPasswordPage;
